import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';


import global_en from "./Traslations/EN/global.json"
import global_fr from "./Traslations/FR/global.json"
import global_it from "./Traslations/IT/global.json"
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';


i18next.init({
    interpolation:{escapeValue:false},
    lng:"en",
    resources:{
        en:{global:global_en},
        fr:{global:global_fr},
        it:{global:global_it}
    }
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<I18nextProvider i18n={i18next} >
    <App />
</I18nextProvider>

);

